import { render, staticRenderFns } from "./WelcomeSpinner.vue?vue&type=template&id=541d77b2&scoped=true"
import script from "./WelcomeSpinner.vue?vue&type=script&lang=js"
export * from "./WelcomeSpinner.vue?vue&type=script&lang=js"
import style0 from "./WelcomeSpinner.vue?vue&type=style&index=0&id=541d77b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541d77b2",
  null
  
)

export default component.exports